export var StorageItem;
(function (StorageItem) {
    StorageItem["ACCESS_TOKEN"] = "access_token";
    StorageItem["EXPIRES_AT"] = "expires_at";
    StorageItem["FHIR_ID"] = "fhir_id";
    StorageItem["FIRST_NAME"] = "first_name";
    StorageItem["MFA_DISMISSED"] = "mfa_dismissed";
    StorageItem["MRN"] = "mrn";
    StorageItem["OKTA_USER_ID"] = "okta_user_id";
    StorageItem["PATIENT_HUB_USER_ID"] = "patient_hub_user_id";
    StorageItem["PRETEST_CONSULT"] = "pretest_consult";
    StorageItem["SELECTED_ORDER_ID"] = "selected_order_id";
    StorageItem["TOKEN_FROM"] = "token_from";
    StorageItem["WAYSTAR_SSO_REDIRECT"] = "waystar_sso_redirect";
})(StorageItem || (StorageItem = {}));
//# sourceMappingURL=storage-item.enum.js.map